import { FormEvent, FunctionComponent, useMemo, useState } from "react";
import { ActionGroup } from "../../../components/layout/actionGroup";
import { Input } from "../../../components/common/input";
import { Button } from "../../../components/common/button";
import {
  Translation,
  useText,
} from "../../../components/dictionary/translation";
import { usePromoCodeMutation } from "../../../store/api/promoCode/endpoints";
import { InfoCard } from "../../../components/cards/info";
import { FormGrid, FormItem } from "../../../components/layout/formGrid";

export interface PromoCodeInputProps {
  orderId: string;
}

export const PromoCodeInput: FunctionComponent<PromoCodeInputProps> = ({
  orderId,
}) => {
  const promoCodeLabel = useText("common.promo-code");
  const [promoCode, setPromoCode] = useState("");

  const [submitPromo, { error, isLoading: isPromoCodeLoading }] =
    usePromoCodeMutation();

  const handlePromoCodeSubmit = (event: FormEvent) => {
    event.preventDefault();
    submitPromo({ orderId, promoCode });
  };

  const errorMessage = useMemo(() => {
    if (error && "data" in error && error?.data) {
      return (error.data as { message?: string })?.message;
    }
    return null;
  }, [error]);

  return (
    <form onSubmit={handlePromoCodeSubmit}>
      <FormGrid>
        <FormItem span={2}>
          <ActionGroup>
            <Input
              type="text"
              placeholder={promoCodeLabel}
              grow
              onChange={(event) => setPromoCode(event.target.value)}
            />
            <Button type="submit" loading={isPromoCodeLoading} text>
              <Translation k={"common.apply"} />
            </Button>
          </ActionGroup>
        </FormItem>
        {errorMessage ? (
          <FormItem span={2}>
            <InfoCard danger>{errorMessage}</InfoCard>
          </FormItem>
        ) : null}
      </FormGrid>
    </form>
  );
};
